BoardStar = require 'models/board-star'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Util = require 'lib/util'
_ = require 'underscore'
Promise = require 'bluebird'

module.exports = class BoardStarList extends CollectionWithHelpers
  model: BoardStar
  url: -> "/1/member/#{ @member.id }/boardStars"

  initialize: (list, { @member }) ->
    @listenTo @, 'change:pos', @sort

  comparator: (boardStar) -> boardStar.get('pos') || 0

  getBoardStar: (idBoard) ->
    _.find @models, (model) -> model.get('idBoard') == idBoard

  starBoard: (idBoard) ->
    if @getBoardStar(idBoard)
      return Promise.reject(new Error("already starred"))

    if @length
      pos = @at(@length - 1).get('pos') + Util.spacing
    else
      pos = Util.spacing

    new Promise (resolve) =>
      @create
        idBoard: idBoard
        pos: pos
      , { @modelCache }, resolve

  unstarBoard: (idBoard) ->
    boardStar = @getBoardStar(idBoard)
    if boardStar?
      new Promise (resolve, reject) ->
        boardStar.waitForId boardStar, ->
          boardStar.destroy
            success: resolve
            error: (xhr, err) -> reject(err)
    else
      Promise.reject(new Error("not starred"))

  updateStarBoard: (idBoard, index) ->
    boardStar = @getBoardStar(idBoard)
    pos = @getNewPos(boardStar, index)

    if boardStar?
      boardStar.update
        pos: pos

  getBoards: ->
    idBoards = @getBoardIds()
    _.compact(@modelCache.get('Board', idBoards))

  getBoardIds: ->
    models = _.sortBy(@models, (model) -> model.get('pos'))
    (model.get('idBoard') for model in models)

  getBoardIndex: (idBoard) ->
    @models.filter getVisibleStarredBoards
    .indexOf(@getBoardStar(idBoard))

  getNewPos: (boardStar, index) ->
    pos = Util.calcPos index, @, boardStar, getVisibleStarredBoards

  getVisibleStarredBoards = (boardStar) ->
    board = boardStar.getBoard()
    board && board.isOpen()



// WEBPACK FOOTER //
// ./app/scripts/models/collections/board-star-list.coffee